import { useNavigate } from "react-router-dom";
import { setNewFilters } from "../redux/filtersSlice";
import { useDispatch } from 'react-redux';

// Questa card è utilizzata sia nella sezione AdviceCategorySection (opzioni di filterString: 'alpine-lakes', 'family', 'hard', 'dog-friendly')
// sia nella sezione ActivityIconSection (filterString: category-nomeCategoria)
const CategoryCard = ({ title, photo, filterString }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    // Gestisco il click sui suggerimenti del mese
    const goToActivities = (filter) => {
        if (filter === 'month') {
            dispatch(setNewFilters({ other: ['isMonthAdviced'] }));
        };
        if (filter === 'alpine-lakes') {
            dispatch(setNewFilters({ other: ['Laghetti alpini'] }));
        };
        if (filter === 'family') {
            dispatch(setNewFilters({ other: ['isForFamily'] }));
        };
        if (filter === 'hard') {
            dispatch(setNewFilters({ difficultyLevel: ['Difficile'] }));
        };
        if (filter === 'dog-friendly') {
            dispatch(setNewFilters({ other: ['isDogFriendly'] }));
        };
        if (filter.slice(0, 8) === 'category') {
            let category = filter.slice(9);
            dispatch(setNewFilters({ category: category }))
        };
        // Infine navigo alla pagina delle attività
        navigate("/all-activities")
    }
    return (
        <div className="flex-1 h-[240px] lg:h-[300px] rounded-xl overflow-hidden relative transition-transform duration-500 ease-in-out transform md:hover:scale-105 cursor-pointer" onClick={() => goToActivities(filterString)}>
            <div className='absolute top-[140px] right-0 bottom-0 left-0 bg-gradient-to-t from-slate-900 to-transparent p-4 flex items-end'>
                <h3 className='text-white'>{title}</h3>
            </div>
            <img src={photo} alt={title} className='h-full w-full object-cover' />
        </div>
    )
}

export default CategoryCard